// Настройки для "пустого" редактора
export const emptySettings = {
  menubar: 'file edit view',
  paste_as_text: true,
  plugins: 'paste',
  setup: (editor) => {
    editor.on('init', () => {
      ['b', 'u', 'i'].forEach((item) => {
        editor.shortcuts.remove(`ctrl+${ item }`)
        editor.shortcuts.remove(`meta+${ item }`)
        editor.addShortcut(`ctrl+${ item }`, 'noop', () => false)
        editor.addShortcut(`meta+${ item }`, 'noop', () => false)
      })
    })
  },
  toolbar: ['undo redo'],
  valid_elements: 'p',
}
